import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useOssuary() {
    //console.log('>>> useCatacombs')
    const { modules: { ossuary: { contract } } } = getENV();
    const { contract: ossuary } = useSmartContract(contract);
    return { ossuary }
}